import React, { useEffect } from 'react';

import Cookies from 'js-cookie';
import { END } from 'redux-saga';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { GetServerSideProps } from 'next';

import SEO from 'components/common/SEO';
import Layout from 'components/Layout';
import { ICartProps } from 'store/modules/cart';
import { IState, SagaStore, storeWrapper } from 'store';
import { IConfigApplicationProps } from 'store/modules/config';
import { loadHomeData, IHomeDataState } from 'store/modules/home';
import { GAEvent, getGAViewItemsHomeList } from 'utils/gtag';

const Timer = dynamic(() => import('components/common/Timer'));
const Mosaic = dynamic(
  () => import('components/common/Templates/Carousel/Mosaic'),
);
const BannersFull = dynamic(
  () => import('components/common/Templates/Carousel/BannersFull'),
);
const Grid = dynamic(() => import('components/common/Templates/Grid'));
const CarouselBrands = dynamic(
  () => import('components/common/Templates/Carousel/CarouselBrands'),
);
const ProductCarousel = dynamic(
  () => import('components/common/Templates/Carousel/ProductCarousel'),
);
const SimpleCarousel = dynamic(
  () => import('components/common/Templates/Carousel/SimpleCarousel'),
);
const RouletteModal = dynamic(() => import('components/common/RouletteModal'));

const ShowcaseGrid = dynamic(
  () => import('components/pages/Showcase/ShowcaseGrid'),
);

import { Container } from 'styles/pages/App/Home';

export default function Home() {
  const router = useRouter();

  const { components, banners, bannersIntermediate } = useSelector<
    IState,
    IHomeDataState
  >(state => state.homeData);
  const { roletaSorte: roletaSortePremio } = useSelector<IState, ICartProps>(
    state => state.cart.cart,
  );
  const { roletaSorte } = useSelector<IState, IConfigApplicationProps>(
    state => state.config.config,
  );

  useEffect(() => {
    if (!router.query?.campanha) {
      Cookies.remove('@SportsNutrition:campanha');
    }
  }, [router]);

  useEffect(() => {
    setTimeout(() => {
      if (components.length) {
        components.map(component => {
          if (component.tipo === 'PRODUTO')
            GAEvent({
              action: 'view_item_list',
              data: getGAViewItemsHomeList({
                products: component.itens,
                itemListId: `HOME - ${component.titulo}`,
                itemListName: `HOME - ${component.titulo}`,
              }),
            });
        });
      }
    }, 10000);

    Cookies.set('@SportsNutrition:itemList', 'HOME');
  }, [components]);

  return (
    <Layout isHome>
      <Container className="home">
        <SEO title="">
          <meta name="cs:page" content="home" />
        </SEO>

        <Timer containerClassName="home" />

        {banners && banners.length > 0 && <BannersFull banners={banners} />}

        {bannersIntermediate &&
          bannersIntermediate.length > 0 &&
          bannersIntermediate.map((banners, index) => (
            <SimpleCarousel key={index} items={banners.banners} />
          ))}

        {components &&
          components.map(component => {
            return (
              <div
                key={component.componenteVitrineId}
                className={`${
                  component.tipo === 'PRODUTO' &&
                  component.template === 'CARROSSEL'
                    ? 'product-carousel-group'
                    : 'component'
                }`}
              >
                {component.exibirTitulo && (
                  <h3 className="component-title">{component.titulo}</h3>
                )}

                {component.tipo === 'MARCA' && (
                  <CarouselBrands items={component.itens} />
                )}

                {component.tipo === 'BANNER' && (
                  <SimpleCarousel items={component.itens} />
                )}

                {component.tipo === 'PRODUTO' &&
                  component.template === 'CARROSSEL' && (
                    <ProductCarousel
                      items={component.itens}
                      componenteVitrineId={component.componenteVitrineId}
                      delay={3000}
                      speed={2000}
                    />
                  )}

                {component.tipo === 'PRODUTO_AUTOMATICO' &&
                  component.template === 'CARROSSEL' && (
                    <ProductCarousel
                      items={component.itens}
                      componenteVitrineId={component.componenteVitrineId}
                      delay={3000}
                      speed={2000}
                    />
                  )}

                {component.tipo === 'PRODUTO' &&
                  component.template === 'GRADE' && (
                    <ShowcaseGrid component={component} />
                  )}

                {component.tipo === 'PRODUTO_AUTOMATICO' &&
                  component.template === 'GRADE' && (
                    <ShowcaseGrid component={component} />
                  )}

                {/* {component.tipo === 'PRODUTO' &&
                  (component.template === 'MOSAICO_LTR' ||
                    component.template === 'MOSAICO_RTL') && (
                    <Mosaic
                      items={component.itens}
                      banner={{
                        bannerImagemUrl: component.bannerImagemUrl,
                        bannerLinkUrl: component.bannerLinkUrl,
                      }}
                      template={component.template}
                      componenteVitrineId={component.componenteVitrineId}
                    />
                  )} */}
              </div>
            );
          })}
      </Container>

      {/* {roletaSorte?.exibirHome && !roletaSortePremio && <RouletteModal />} */}
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps =
  storeWrapper.getServerSideProps(async ({ query, store, res }) => {
    res.setHeader(
      'Cache-Control',
      'public, s-maxage=10, stale-while-revalidate=59',
    );

    const { vitrineId } = query;

    store.dispatch(loadHomeData(vitrineId ? String(vitrineId) : null));
    store.dispatch(END);

    await (store as SagaStore).sagaTask.toPromise();

    return {
      props: {},
    };
  });
